import React, { createContext, useContext } from 'react';
import { AmbientAudio, useAmbientAudio } from '../hooks/useAmbientAudio';
const AmbientContext = createContext<AmbientAudio | null>(null);
export function AmbientProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const audio = useAmbientAudio();
  return <AmbientContext.Provider value={audio} data-id="element-84" data-mp="26bj98sr4xjky">{children}</AmbientContext.Provider>;
}
export function useAmbient(): AmbientAudio {
  const ctx = useContext(AmbientContext);
  if (!ctx) throw new Error('useAmbient must be used inside AmbientProvider');
  return ctx;
}